module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "thumbnail"
  }, [_c('alert', {
    attrs: {
      "placement": "top",
      "duration": "5000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.picture_url || _vm.picture),
      expression: "picture_url || picture"
    }]
  }, [_c('div', {
    staticClass: "img-icon"
  }, [_c('div', {
    staticClass: "btn-change"
  }, [_c('label', [_c('span', {
    staticClass: "btn-change btn btn-primary btn-sm",
    attrs: {
      "variant": "danger",
      "size": "sm"
    }
  }, [_vm._v("Change")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "type": "file",
      "accept": ".jpg, .jpeg, .png"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileChange($event, $event.target.parentElement.parentElement.parentElement.children[1])
      }
    }
  })])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.pictureUrlLocal
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "btn-delete btn btn-danger btn-sm",
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.deletePicture($event)
      }
    }
  }, [_vm._v("Delete")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.picture_url || _vm.picture)),
      expression: "!(picture_url || picture)"
    }]
  }, [_c('b-form-file', {
    ref: "fileinput",
    attrs: {
      "choose-label": "Choose Image",
      "accept": ".jpg, .jpeg, .png"
    },
    on: {
      "change": function($event) {
        return _vm.handleFileChange($event, $event.target.parentElement.parentElement.parentElement.children[1].children[0].children[1])
      }
    },
    model: {
      value: (_vm.pictureLocal),
      callback: function($$v) {
        _vm.pictureLocal = $$v
      },
      expression: "pictureLocal"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a55cf160","hasScoped":true}!./src/components/thumbnail/thumbnail.component.html
// module id = 550
// module chunks = 1